import React, { useState, useEffect } from 'react';
import ProductCard from './ProductCard';
import { useLanguage } from '../context/LanguageContext';
import { getRecentlyViewedIds, pruneRecentlyViewed } from '../utils/recentlyViewed';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const RecentlyViewed = () => {
  const { t } = useLanguage();
  const [products, setProducts] = useState([]);

  useEffect(() => {
    const ids = getRecentlyViewedIds();
    if (ids.length === 0) {
      setProducts([]);
      return;
    }

    // Re-fetch from the live catalog instead of trusting the cached snapshot -
    // a product may have been deleted/hidden since it was cached, and stale
    // ids must never be rendered (they'd send Meta Pixel events for products
    // that no longer exist/match the catalog).
    let cancelled = false;
    (async () => {
      try {
        const res = await fetch(`${API_URL}/api/products?ids=${ids.join(',')}&limit=${ids.length}`);
        if (!res.ok || cancelled) return;
        const data = await res.json();
        const liveProducts = data.products || [];
        const byId = new Map(liveProducts.map(p => [p.id, p]));
        // Preserve most-recently-viewed order, drop ids no longer valid
        const ordered = ids.map(id => byId.get(id)).filter(Boolean);
        setProducts(ordered);
        pruneRecentlyViewed(ordered.map(p => p.id));
      } catch {
        setProducts([]);
      }
    })();

    return () => { cancelled = true; };
  }, []);

  // Don't render anything if no products viewed
  if (products.length === 0) {
    return null;
  }

  return (
    <section className="section-padding-small" data-testid="recently-viewed-section">
      <div className="container">
        <h2 className="section-title">{t('recentlyViewed')}</h2>
        <div className="grid-product-showcase" data-testid="recently-viewed-grid">
          {products.map(product => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default RecentlyViewed;
